const COMPLETE_QUALITY_LIMIT = 100;
const HIGH_QUALITY_LIMIT = 80;
const MEDIUM_QUALITY_LIMIT = 40;

export type Status = 'low' | 'medium' | 'high' | 'pending' | 'failed' | 'completed';

export const i18ns: Record<Exclude<Status, 'pending' | 'failed'>, { title: string; body: string }> = {
  completed: {
    title: 'JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_HIGH_TITLE',
    body: 'JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_HIGH_BODY',
  },
  high: {
    title: 'JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_HIGH_TITLE',
    body: 'JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_HIGH_BODY',
  },
  medium: {
    title: 'JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_MEDIUM_TITLE',
    body: 'JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_MEDIUM_BODY',
  },
  low: {
    title: 'JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_LOW_TITLE',
    body: 'JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_LOW_BODY',
  },
};

export const getProfileCompletionStatus = (normalizedScore: number): Status => {
  return normalizedScore <= HIGH_QUALITY_LIMIT
    ? normalizedScore <= MEDIUM_QUALITY_LIMIT
      ? 'low'
      : 'medium'
    : normalizedScore == COMPLETE_QUALITY_LIMIT
    ? 'completed'
    : 'high';
};

export const getNormalizedToFiveMultipleScore = (score?: number) => (score ? Math.round(score / 5) * 5 : 0);
